import './login.scss';

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import AuthComponent from './auth-provider';
import { Button } from 'react-bootstrap';
import SessionStorageService from '../../../common/services/session-storage-service';
import logo from '../../../images/PMC-logo.png';

@inject('AuthStore')
@observer
class LoginContainer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="login-container">
        <div className="login-container__content">
          <div className="login-container__logo">
            <img className="login-container-logo" src={logo} alt="Logo" />
          </div>
          <div className="header__text d-none d-sm-block">
            Reference Data Grid
          </div>

          <Button className="mt-3 mb-3 custom-btn" onClick={this.handleLogin}>
            Login
          </Button>

          <div className="account-container__footer"></div>
        </div>
      </div>
    );
  }

  handleLogin = () => {
    const { history, AuthStore, location: { state, pathname } } = this.props;
    AuthComponent.onSignIn().then((response) => {
      SessionStorageService.setAuthToken(response);
      AuthStore.setLoggedInStatus(true);
      AuthStore.setUsername(response.userName);
      AuthStore.setDisplayName(response.displayName);
      AuthStore.setUserRole(response.roles);
      AuthStore.setAccessToken(response.accessToken);
      const { from } = state || { from: { pathname: (pathname === '/login' ? '/' : pathname) } };
      history.push(from);
    });
  };
}

export default LoginContainer;
